import ParentView from '@/components/ParentView'
import Layout from '@/layout'

const managementRoutes = {
  path: '/base/system/task',
  component: Layout,
  funcPerms: '',
  name: 'task',
  meta: {
    title: '任务管理',
    // icon: 'el-icon-s-grid',
    icon: 'index',
    affix: false,
    noCache: true
  },
  children: [
    {
      path: '/myProcess/index',
      component: () => import('@/views/flowable/task/myProcess/index'),
      funcPerms: '',
      name: 'task-my',
      meta: {
        title: '我的流程',
        // icon: 'el-icon-menu',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'todo/list',
      component: () => import('@/views/flowable/task/todo/index'),
      funcPerms: '',
      name: 'task-todo',
      meta: {
        title: '待办任务',
        // icon: 'el-icon-menu',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: '/finished/list',
      component: () => import('@/views/flowable/task/finished/index'),
      funcPerms: '',
      name: 'task-finished',
      meta: {
        title: '已办任务',
        // icon: 'el-icon-menu',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'finished/detail/index',
      component: () => import('@/views/flowable/task/finished/detail/index'),
      name: 'FinishedRecord',
      meta: { title: '流程详情', icon: '' },
      hidden: true
    },
    {
      path: 'myProcess/detail/index',
      component: () => import('@/views/flowable/task/myProcess/detail/index'),
      name: 'MyProcessRecord',
      meta: { title: '流程详情', icon: '' },
      hidden: true
    },
    {
      path: 'myProcess/send/index',
      component: () => import('@/views/flowable/task/myProcess/send/index'),
      name: 'SendRecord',
      meta: { title: '流程发起', icon: '' },
      hidden: true

    },
    {
      path: 'todo/detail/index',
      component: () => import('@/views/flowable/task/todo/detail/index'),
      name: 'TodoRecord',
      meta: { title: '流程处理', icon: '' },
      hidden: true

    }

    // {
    //   path: 'listener/list',
    //   component: () => import('@/views/flowable/task/copy/index'),
    //   funcPerms: 'system:setting:auth:menus',
    //   name: 'auth-func',
    //   meta: {
    //     title: '抄送任务',
    //     // icon: 'el-icon-menu',
    //     icon: 'index',
    //     affix: false,
    //     noCache: true
    //   }
    // }

  ]
}

export default managementRoutes
